import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { Row, Col, Container, CardBody, Button, Card } from 'reactstrap';
import * as commonActions from '@common/common.action';
import * as actions from './store/relatorios.action';
import ComponentesDescarte from '../../common/components';
import * as DefautValues from '@common/util/defaultValues';
import DescarteApi from '../../descarte.api';
import Sepultamento from '../../common/components/Sepultamento';
import Padrao from '../../common/components/Padrao';
import GridSepultamentoIndividual from './GridSepultamentoIndividual';
import SelectComponent from '@componentes/select/select.component';
import Especial from '../../common/components/Especial';
import IntlMessage from '../../../../helpers/intlMessage';
import { injectIntl } from 'react-intl';
import CommonFunctions from '@util/functions.common';

 function Descarte (props) {
  const componentRef = useRef();
  const dispatch = useDispatch();
  const descarteRelatorios = useSelector(state => state.descarteRelatorios);
  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
    );
  
    const {messages} = props.intl;
    const [tipoDescarte, setTipoDescarte] = useState('');
    const [selectFilter, setSelectFIlter] = useState('');
    const [search, setSearch] = useState(false);
    const [listaTemporaria, setListaTemporaria] = useState([]);

    const optionsTipoDescarte = DefautValues.tipoDescarteOptions.map(x => {
      return {...x, label: messages[x.label] ? messages[x.label] : x.label}
    });

    const optionsDescarte = DefautValues.optionsFiltroDescarte.map(x => {
      return {...x, label: messages[x.label] ? messages[x.label] : x.label}
    });

  useEffect(() => {
    dispatch(actions.lista([]));
  }, []);

  useEffect(() => {
    setListaTemporaria(descarteRelatorios.lista);
  }, [descarteRelatorios.lista]);

  function changeFilter (e) {
    setSelectFIlter(e.value);
  }

  function showMessageByResults (results) {
    if (results > 0) {
        const mensagem = <IntlMessage id = "dashboards.disposalMaterials.dataSucessfully"/>
          dispatch(commonActions.showAlerta('sucesso', mensagem, 10));
    } else {
      dispatch(
        commonActions.showAlerta('alerta', <IntlMessage id = "dashboards.disposalMaterials.noResult"/>, 3000)
      );
    }
  }

  function changeTipoDescarte (e) {
    const tipo = Number(e.value) === 3 ? 2 : Number(e.value);
    const listaByTipo = listaTemporaria.filter(x => x.tipoDescarte === tipo);
    dispatch(actions.lista(listaByTipo));
    setTipoDescarte(e.value);
  }

  function handleLoadData () {
    const { filtroValue, dataInicio, dataFim } = descarteRelatorios;

    let executarValidacaoDeData = (selectFilter.indexOf('dt') >= 0);
    let result = {valid: true, message: ''};

    if (executarValidacaoDeData)
      result = CommonFunctions.validaData(dataInicio, dataFim, props.intl, commonActions);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    setSearch(true);
    dispatch(commonActions.showFadeCarregando(true));
    const tipo = Number(tipoDescarte) === 3 ? 2 : Number(tipoDescarte);

    DescarteApi.getItensRelatorio(
      tipo,
      selectFilter,
      filtroValue,
      dataInicio,
      dataFim
    ).then(resp => {
      dispatch(commonActions.showFadeCarregando(false));
      dispatch(actions.lista(resp));
      setListaTemporaria(resp);
      showMessageByResults(resp.length);
    });
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  return (
    <React.Fragment>
      <div className='mv-descarte-tab relatorios'>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col xs={2}>
                    <SelectComponent
                      options={optionsTipoDescarte}
                      placeholder={messages["dashboards.disposalMaterials.reportType"]}
                      defaultValue={tipoDescarte}
                      onChange={e => changeTipoDescarte(e)}
                    />
                  </Col>
                  <Col xs={3} style={{ maxWidth: 240 }}>
                    <SelectComponent
                      options={optionsDescarte}
                      placeholder={messages["dashboards.disposalMaterials.chooseOne"]}
                      defaultValue={selectFilter}
                      onChange={e => changeFilter(e)}
                      disabled={tipoDescarte === ''}
                    />
                  </Col>
                  {selectFilter && (
                    <div className='col-auto'>
                      {selectFilter && (
                        <ComponentesDescarte
                          component={selectFilter}
                          onPressEnter={handleLoadData}
                        />
                      )}
                    </div>
                  )}
                  <Col xs={1}>
                    <Button
                      style={{ height: '38px', width: '38px'}}
                      className='btn btn-primary'
                      disabled={!selectFilter || tipoDescarte === ''}
                      onClick={handleLoadData}
                    >
                      <i className='icons-btn mv-basico-pesquisar'></i>
                    </Button>
                  </Col>
                  <Col>
                    {!!descarteRelatorios.lista.length &&
                      (tipoDescarte === DefautValues.tipoDescarteEmum.PADRAO ||
                        tipoDescarte ===
                          DefautValues.tipoDescarteEmum.SEPULTAMENTO ||
                        tipoDescarte ===
                          DefautValues.tipoDescarteEmum.ESPECIAL) && (
                        <Button
                          className='btn btn-imprimir btn-success'
                          onClick={handlePrint}
                        >
                          <i className='icons-btn mv-basico-imprimir'></i>{' '}
                          <IntlMessage id = "dashboards.taskControl.printOut"/>
                        </Button>
                      )}
                    {!!descarteRelatorios.lista.length &&
                      tipoDescarte ===
                        DefautValues.tipoDescarteEmum
                          .SEPULTAMENTO_INDIVIDUAL && (
                        <Button
                          className='btn btn-imprimir btn-success'
                          onClick={() => dispatch(actions.imprimir(true))}
                        >
                          <i className='icons-btn mv-basico-imprimir'></i>{' '}
                          <IntlMessage id = "dashboards.taskControl.printOut"/>
                        </Button>
                      )}
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {!!descarteRelatorios.lista.length && (
              <Card>
                <CardBody
                  style={{
                    height: '82vh',
                    overflow: 'scroll',
                    overflowX: 'hidden'
                  }}
                >
                  <Container fluid>
                    <div ref={componentRef}>
                      <div>
                        {tipoDescarte ===
                          DefautValues.tipoDescarteEmum.PADRAO && (
                          <Padrao lista={descarteRelatorios.lista} />
                        )}
                        {tipoDescarte ===
                          DefautValues.tipoDescarteEmum.SEPULTAMENTO && (
                          <Sepultamento lista={descarteRelatorios.lista} />
                        )}
                        {tipoDescarte ===
                          DefautValues.tipoDescarteEmum.ESPECIAL && (
                          <Especial lista={descarteRelatorios.lista} />
                        )}
                        {tipoDescarte ===
                          DefautValues.tipoDescarteEmum
                            .SEPULTAMENTO_INDIVIDUAL && (
                          <GridSepultamentoIndividual
                            lista={descarteRelatorios.lista}
                          />
                        )}
                      </div>
                    </div>
                  </Container>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
        {!search && (
          <div className='icone-semdados'>
            <i className='inicial-icons mv-basico-documento_eletronico'></i>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default injectIntl(Descarte);


// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/relatorios/index.js